const backgroundImage =
  'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cloud%20Migration/cloud-bg-3.png';

export default function NewHero() {
  return (
    <section
      id="top"
      aria-labelledby="cloud-migration-heading"
      className="relative isolate w-full lg:grid"
      style={{ backgroundColor: '#081f43', color: '#fff' }}
    >
      {/* The intrinsic dimensions preserve the complete artwork and its height. */}
      <img
        src={backgroundImage}
        width={1177}
        height={326}
        alt=""
        fetchPriority="high"
        className="block aspect-[1177/326] h-auto w-full lg:col-start-1 lg:row-start-1 lg:self-center"
      />

      <div className="relative min-w-0 px-[clamp(16px,4vw,64px)] py-[clamp(24px,4vw,40px)] lg:col-start-1 lg:row-start-1 lg:flex lg:items-center lg:py-[clamp(16px,1.6vw,32px)]">
        <div className="min-h-[189px] w-full min-w-0 max-w-[640px] break-words text-left lg:w-[55%]">
          <h1
            id="cloud-migration-heading"
            className="m-0 text-[clamp(28px,3vw,44px)] font-semibold leading-[1.2] tracking-[-0.025em]"
            style={{ color: '#fff' }}
          >
            Cloud Migration Services
          </h1>
        </div>
      </div>
    </section>
  );
}
